console.log("gokwik_only_checkout");

(function () {
  "use strict";

  function setDisplay(selector, displayValue) {
    document.querySelectorAll(selector).forEach(function (element) {
      element.style.setProperty("display", displayValue, "important");
    });
  }

  function applyMainCheckout() {
    setDisplay(".gokwik-wrapper", "block");
    setDisplay(".shopflo-wrapper", "none");
  }

  function applyCartCheckout() {
    setDisplay(".gokwik-wrapper-cart", "block");
    setDisplay(".shopflo-wrapper-cart", "none");
  }

  function applyBuyNowCheckout() {
    setDisplay("#gokwik-wrapper-buy", "block");
    setDisplay("#shopflo-wrapper-buy", "none");
    setDisplay("#gokwik-wrapper-buy-mobile", "block");
    setDisplay("#shopflo-wrapper-buy-mobile", "none");
  }

  function displaySelectedButton() {
    console.log("run for checkout");
    console.log("gokwik");
    applyMainCheckout();
  }

  function displaySelectedButtonCart() {
    applyCartCheckout();
  }

  function displaySelectedButtonBuyNow() {
    applyBuyNowCheckout();
  }

  function applyAll() {
    try { displaySelectedButton(); } catch (e) { console.warn("displaySelectedButton failed", e); }
    try { displaySelectedButtonCart(); } catch (e) { console.warn("displaySelectedButtonCart failed", e); }
    try { displaySelectedButtonBuyNow(); } catch (e) { console.warn("displaySelectedButtonBuyNow failed", e); }
  }

  window.displaySelectedButton = displaySelectedButton;
  window.displaySelectedButtonCart = displaySelectedButtonCart;
  window.displaySelectedButtonBuyNow = displaySelectedButtonBuyNow;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  } else {
    applyAll();
  }

  var observer = new MutationObserver(function () {
    applyAll();
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();